<template>
  <b-container fluid class="headerPushDown">
    <b-container class=" ml-auto mr-auto mb-4">
      <h2 class="text-center ueberschriften">Tisch buchen</h2>
    </b-container>

    <!-- SELECTION -->
    <b-container class="p-0 mb-2">

      <b-row class="justify-content-center" v-if="products" >
        <b-col cols="6" sm="4" md="3" lg="2" class="text-center mb-2 mb-md-0" style="cursor: pointer;" v-for="(item, index) in products" v-bind:key="index" @click="clickItemIcon(index)">
          <b-row class="">
            <b-col cols="12" class="">
              <div v-html="item.iconBig" class="SVGimage ml-auto mr-auto"></div>
            </b-col>
            <b-col cols="12">
              <div class="text-uppercase text-center mt-2 BookingIconTitle" v-html="item.title"></div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>


<div v-if="selectedGroup != undefined && products != undefined" class="ml-2 mr-2 bookingcarousel mt-4" >

      <slick ref="slick" :options="slickOptions" v-if="products.length >0" style="cursor:ew-resize;">
        <div v-for="(voucher, index) in products" :key="index" class="ml-2 ml-md-0 mr-2 mr-md-0" >
          <b-row style="padding-left: 1em; padding-right: 1em;" class="">
            <b-col cols="12" md="5" class="p-0">
              <div>
                <img :src="voucher.images[0]" width="100%" class="float-right pl-2 pt-2 pr-3">
              </div>
            </b-col>
            <b-col cols="12" md="7" class="p-2 m-0">
              <b-row class="">
                <b-col cols="1" md="1" class="p-0 ml-3 ml-md-1 mt-3">
                  <div class="pt-1 pt-md-2" v-html="voucher.iconSmall">
                  </div>
                </b-col>
                <b-col cols="10" md="10" class="">
                  <div class="mt-3 title-small text-uppercase letter-spacing-3 black-text font-weight-600" v-html="voucher.title"></div>
                  <div class="mt-3 ml-2" v-html="voucher.shortDescription">
                  </div>
                  <div class="mt-2 ml-2" v-html="voucher.shortPriceInfo"></div>
                  <div class="mt-2  ml-2 event-time" v-html="voucher.priceInfo"></div>
                </b-col>

                <b-col cols="12" md="11" class="justify-content-end mt-1 p-0">
                  <b-btn size="md"  @click="go('/app/'+ voucher.type +'/'+ voucher.id)" class="mb-3 mr-5 text-uppercase float-right">Platz nehmen</b-btn>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </div>
      </slick>
    </div>
    <div v-else style="min-height:400px;">
     <!-- MESSAGE LOADING OF PRODUCTS -->
    </div>
</b-container>

    <!-- CALENDAR -->
    <shop-calendar/>

  </b-container>
</template>
<script>

import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import shopCalendar from '@/components/ShopCalendar.vue'

export default {
  name: 'shopTicketIndex',
  components: {
     Slick, shopCalendar
  },
  data() {
    return {
      panelData: [],
      selectedGroup: undefined,
      products: undefined,
      slide: 0,
      sliding: null,
      slickOptions: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    };
  },
  computed: {
    getSelectedLanguage() {
        return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
  },
  methods: {
  onSlideStart(/* slide */) {
      this.sliding = true
    },
    onSlideEnd(/* slide */) {
      this.sliding = false
    },
    clickGroupIcon(group){
     // console.log('click Group: ', group);
      this.selectedGroup = group;

      this.products =  this.loadProductsFromServer(group);

    },
    clickItemIcon(index){
      //console.log('slide: ', this.$refs.slick);
      this.slide = index;
      this.$refs.slick.goTo(this.slide);
    },
    getSVG(item){
      return "data:image/svg+xml;charset=utf-8, " + item.iconBig ;
    },
    go: function(route) {
      /* go to category... */
      //console.log('go: ' ,route);
      this.$router.push(route);
    },
    async loadGroupsFromServer(searchTags) {

      let config =this.$store.getters.getRestHeaderConfig;
      config.params = {
          searchTags: searchTags,
          imageSize: "big" /* small, medium, big */,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      await this.$http
        .get(
          this.$store.getters.getRestServerBaseUrl + "/productGroups",
          config
        )
        .then(response => {
          //console.log("productGroups: ", searchTags, response.data);
          // Check Data ?
          if(response.data != undefined && response.data.length > 0 ){

            this.panelData = response.data;

            this.panelData.forEach((g) => {
             // console.log('updating Group: ', g.id);
               //this loads Details and Products and puts it into the given group
               g.details =  this.loadProductDetailsFromServer(g);
          //    /* g.products = */ this.loadProductsFromServer(g);
            });

            // if we run the first time, select first group
            if(this.selectedGroup == undefined && this.panelData[0] != undefined){
             // console.log('Select first group:', this.panelData[0]);

              this.selectedGroup = this.panelData[0];

              this.products = this.loadProductsFromServer(this.selectedGroup);
            }
          }else{
            //console.log('productGroups ERROR: No Data received');
          }
        })
        .catch(err => {
          console.log('Product groups ERROR: ',err);
          this.panelData = [];
        });
    },
    async loadProductDetailsFromServer(group) {
      let config =this.$store.getters.getRestHeaderConfig;
      config.params= {
        groupId: group.id,
        imageSize: "big" /* small, medium, big */,
        localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      // Group Details
      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/productGroupDetail", config)
        .then(response => {
          //console.log("Group OK: ", response.status, response.data);
         // group.details =  response.data;
          return  response.data;
        })
        .catch(err => {
          console.log('GroupDetail ERROR: ', err);

        });
    },
    async loadProductsFromServer(group) {
      let config =this.$store.getters.getRestHeaderConfig;
      config.params= {
        groupId: group.id,
        imageSize: "big" /* small, medium, big */,
        localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      // GroupProducts
      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/products", config)
        .then(response2 => {
          //console.log("Products for group OK: ", response2.status, group.id , response2.data );
          this.products = response2.data;

          return response2.data;
        })
        .catch(err => {
          console.log("/products ERORR", err);
        });
    },

  },
  beforeMount() {

  },
  mounted(){
    /* Load Groups to show in Panel */
    this.loadGroupsFromServer("SidemenuTickets");
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
</script>
